// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__cB2JN","container":"styles_container__ZrT48","slideInSearchBar":"styles_slideInSearchBar__tIEyC"};